abstract class MaybePrototype<T> {
    andThen<U>(_transformer: (value: T) => U): Maybe<NonNullable<U>> {
        // @ts-ignore
        return this;
    }

    fallbackTo<U extends {}>(_value: U): Something<U> {
        // @ts-ignore
        return this;
    }
}

class Nothing<T extends {}> extends MaybePrototype<T> {
    readonly value = null;

    fallbackTo<U extends {}>(value: U): Something<U> {
        return new Something(value);
    }
}

class Something<T extends {}> extends MaybePrototype<T> {
    constructor(readonly value: T) {
        super();
    }

    andThen<U>(transformer: (value: T) => U): Maybe<NonNullable<U>> {
        return Maybe.from(transformer(this.value));
    }
}

export type Maybe<T extends {}> = Nothing<T> | Something<T>;

export namespace Maybe {
    export const from = <T>(value: T): Maybe<NonNullable<T>> => {
        if (value instanceof Nothing || value instanceof Something) {
            return value;
        }
        if (!value) {
            return new Nothing<NonNullable<T>>();
        } else {
            return new Something(value);
        }
    };
}
